import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use( [ Navigation, Pagination ] );
/**
 * File swiper-slider.js
 *
 */

/**
 * Swiper slider functionality.
 *
 * @author Tony Dieu
 * @since June 12, 2021
 */
function wdsSwiperSlider() {
	new Swiper( '.mySwiper', {
		loop: true,
		slidesPerView: 1,
		// pagination: {
		// 	el: '.swiper-pagination',
		// 	type: 'fraction',
		// },
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	} );
}

// Make sure everything is loaded first.
if (
	( 'complete' === document.readyState ||
		'loading' !== document.readyState ) &&
	! document.documentElement.doScroll
) {
	wdsSwiperSlider();
} else {
	document.addEventListener( 'DOMContentLoaded', wdsSwiperSlider );
}

// Fire off our function.
// wdsSwiperSlider();
